var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76665 0.741675L4.99999 3.97501L8.23332 0.741675C8.55832 0.416675 9.08332 0.416675 9.40832 0.741675C9.73332 1.06667 9.73332 1.59167 9.40832 1.91667L5.58332 5.74167C5.25832 6.06668 4.73332 6.06668 4.40832 5.74167L0.583319 1.91667C0.258319 1.59167 0.258319 1.06667 0.583319 0.741675C0.908319 0.425008 1.44165 0.416675 1.76665 0.741675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdownIcon);
export default __webpack_public_path__ + "static/media/arrowdown-icon.97b803c59247253e13e6ebc2460cc42f.svg";
export { ForwardRef as ReactComponent };